module.exports = __webpack_public_path__ + "img/PS19.6964022b.png";